import { ref } from 'vue'
import { defineStore } from 'pinia'

import otherChildEditionIdsApi from '@/services/http/api/otherChildEditionIds'
import { shouldRetryGetActionForAssignedEndpoint } from '@/helpers/retryActionForOtherEndpoint'
import { throwIfInvalidChildEditionId } from '@/helpers/stores/axiosErrorCheck'
import type { GetOtherChildEditionIdsPayload, OtherChildEdition } from '@/types'

export const useOtherChildEditionIdsStore = defineStore('otherChildEditionIds', () => {
  const loader = ref<boolean>(false)
  const otherChildEditionIds = ref<OtherChildEdition[]>([])

  const clear = () => {
    loader.value = false
    otherChildEditionIds.value = []
  }

  const fetchOtherChildEditionIds = async (payload: GetOtherChildEditionIdsPayload) => {
    throwIfInvalidChildEditionId(payload?.childEditionId)

    loader.value = true

    try {
      const { data } = await otherChildEditionIdsApi.get(payload, payload?.getAssignedFirst)
      otherChildEditionIds.value = data?.data || []
    } catch (error) {
      if (shouldRetryGetActionForAssignedEndpoint(error, payload)) {
        await fetchOtherChildEditionIds({ ...payload, getAssignedFirst: true })
      }
    } finally {
      loader.value = false
    }
  }

  return {
    loader,
    otherChildEditionIds,
    fetchOtherChildEditionIds,
    clear
  }
})
